import {
  USER_SESSION,
  LOGIN_USER,
  FORGOT_PASSWORD,
  RESET_PASSWORD,
  CHANGE_PASSWORD,
  LOGOUT_USER,
  USER_SESSION_FAILURE,
} from "../actionTypes";
import { takeEvery, fork, put, all, call } from "redux-saga/effects";
import Cookies from 'js-cookie'

import {
  LoginService,
  SessionService,
  ChangePasswordService,
  ForgotPasswordService,
  ResetPasswordService,
  LogoutService,
  RefreshSessionService,
} from "../../services/auth";

import {
  loginUserSuccess,
  loginUserFailure,
  UserSessionSuccess,
  UserSessionFailure,
  changePasswordCtaSuccess,
  changePasswordCtaFailure,
  logoutUserSuccess,
  logoutUserFailure,
  forgotPasswordCtaSuccess,
  forgotPasswordCtaFailure,
  resetPasswordCtaSuccess,
  resetPasswordCtaFailure,
  UserSession as mkUserSession,
} from "./actions";

import Axios from "../../apiClient/instance/Axios";
import { getMixpanelAdminType, Mixpanel } from "../../services/Mixpanel";


const saveJWT = (jwtKey, jwtValue) => {
  if (window.location.hostname === 'localhost'){
    Cookies.set(jwtKey,jwtValue)
  } else {
    Cookies.set(jwtKey,jwtValue,{sameSite:'None',expires:30,domain:'cerebry.co',secure:true})
  }
};

function handleJWT(jwt, jwt_refresh) {
  localStorage.setItem("jwt", jwt);
  localStorage.setItem("jwt_refresh", jwt_refresh);
  saveJWT("cerebry-jwt-token", jwt);
  saveJWT("cerebry-jwt-refresh", jwt_refresh);
  Axios.defaults.headers["Authorization"] = `jwt ${jwt}`;
}

function handleLogout() {
  localStorage.clear();
  Axios.defaults.headers["Authorization"] = "";
  // window.location.href="/sign-in";
}

function* userLogin(action) {
  try {
    const response = yield call(LoginService, action.payload);
    if (response.status < 400) {
      yield put(loginUserSuccess(response.data));
      const { jwt, jwt_refresh } = response.data;
      handleJWT(jwt, jwt_refresh);
      const adminType = getMixpanelAdminType(response?.data?.groups);
      const language = response.data.language || "eng"; 
      yield put({ type: "CHANGE_LANGUAGE", lang: language });
      Mixpanel.track("Competition_Admin_Login_Clicked", {
        "Admin_Type": adminType
      });
      Mixpanel.identify(response?.data?.id);
      Mixpanel.people.set({
        "$email": response?.data?.email,
        "$distinct_id": response?.data?.id,
        "SchoolID": adminType != "SuperAdmin" ? response?.data?.school: undefined,
        "SchoolName": adminType != "SuperAdmin" ? response?.data?.organization: undefined,
        "OrganisationName": adminType == "SuperAdmin" ? response?.data?.organization: undefined,
      });
    } else {
      yield put(loginUserFailure(response.data.message));
    }
  } catch (error) {
    yield put(loginUserFailure(error));
  }
}

function* userLogout() {
  try {
    const response = yield call(LogoutService);
    if (response.status < 400) {
      yield put(logoutUserSuccess());
      handleLogout();
    } else {
      yield put(logoutUserFailure(response.data.message));
    }
  } catch (error) {
    yield put(logoutUserFailure(error));
  }
}

function* userSession(action) {
  try {
    const response = yield call(SessionService, action.payload);
    if (response.status < 400) {
      const language = response.data.language || "eng"; 
      yield put(UserSessionSuccess(response.data));
      const { jwt, jwt_refresh } = response.data;
      handleJWT(jwt, jwt_refresh);
      yield put({ type: "CHANGE_LANGUAGE", lang: language });
    } else {
      yield put(UserSessionFailure(response.data.message));
    }
  } catch (error) {
    yield put(UserSessionFailure(error));
  }
}

// function* refreshSession() {
// 	try {
// 		const response = yield call(RefreshSessionService);
//     if (response.status < 400) {
// 			const { jwt } = response.data;
// 			handleJWT(jwt, localStorage.getItem("jwt_refresh"));
//       // yield put(mkUserSession());
//     } else if (response.status === 401) {
//       handleLogout();
//     }
//   } catch (error) {
//     handleLogout();
//   }
// }

function* userChangePassword(action) {
  try {
    const response = yield call(ChangePasswordService, action.payload);
    if (response.status < 400) {
      yield put(changePasswordCtaSuccess());
      Mixpanel.track("Competition_Admin_Password_Changed", {
        "Admin_Type": getMixpanelAdminType(response?.data?.groups)
      });
      Mixpanel.people.set({
        "$email": response?.data?.email,
        "$distinct_id": response?.data?.id
      });
    } else {
      yield put(changePasswordCtaFailure(response.data.message));
    }
  } catch (error) {
    yield put(changePasswordCtaFailure(error.data.message));
  }
}

function* userForgotPassword(action) {
  try {
    const response = yield call(ForgotPasswordService, action.payload);
    if ([200, 201, 304].includes(response.status)) {
      yield put(forgotPasswordCtaSuccess());
    } else {
      yield put(forgotPasswordCtaFailure(response.data.message));
    }
  } catch (error) {
    yield put(forgotPasswordCtaFailure(error.data.message));
  }
}

function* userResetPassword(action) {
  try {
    const response = yield call(ResetPasswordService, action.payload);
    if ([200, 201, 304].includes(response.status)) {
      yield put(resetPasswordCtaSuccess());
    } else {
      yield put(resetPasswordCtaFailure(response.data.message));
    }
  } catch (error) {
    yield put(resetPasswordCtaFailure(error.data.message));
  }
}

export function* watchLoginUser() {
  yield takeEvery(LOGIN_USER, userLogin);
}

export function* watchLogoutUser() {
  yield takeEvery(LOGOUT_USER, userLogout);
}

export function* watchUserSession() {
  yield takeEvery(USER_SESSION, userSession);
}

// export function* watchUserSessionFailed() {
//   yield takeEvery(USER_SESSION_FAILURE, refreshSession);
// }

export function* watchChangePassword() {
  yield takeEvery(CHANGE_PASSWORD, userChangePassword);
}

export function* watchForgotPassword() {
  yield takeEvery(FORGOT_PASSWORD, userForgotPassword);
}

export function* watchResetPassword() {
  yield takeEvery(RESET_PASSWORD, userResetPassword);
}

function* AuthSaga() {
  yield all([fork(watchUserSession)]);
  // yield all([fork(watchUserSessionFailed)]);
  yield all([fork(watchLoginUser)]);
  yield all([fork(watchLogoutUser)]);
  yield all([fork(watchChangePassword)]);
  yield all([fork(watchForgotPassword)]);
  yield all([fork(watchResetPassword)]);
}

export default AuthSaga;
